<template>
  <div ref="container">
    <a-modal :z-index="199" :title="title" width="90%" :visible="visible" :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @cancel="handleCancel" cancelText="关闭" style="top:20px;">
      <template slot="footer">
<!--        <a-button key="back" v-if="!uuid" type="primary" @click="submit">确认</a-button>-->
        <a-button key="back" @click="handleCancel">关闭</a-button>
      </template>
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="26" :sm="24">
              <a-form-item label="UDI编码" >
                <a-input v-model="topQueryParam.code"  style="width: 300px;margin-right: 20px"></a-input>
                <a-button type="primary" @click="searchQuery">查询</a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- table区域-begin -->
      <a-table bordered ref="table" size="middle"  rowKey="id" :columns="columns"
               :dataSource="dataSource" :loading="loading" @change="handleTableChange"
               :pagination="ipagination" >
        <span slot="packType" slot-scope="text, record">
          <span>{{record.ptype}}级包装</span>
        </span>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
// import BillDetail from '../../bill/dialog/BillDetail'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JEllipsis from '@/components/jeecg/JEllipsis'
import { findBillDetailByNumber, codeDetails } from '@/api/api'
import { mixinDevice } from '@/utils/mixin'

export default {
  name: 'MaterialInOutList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    // BillDetail,
    JEllipsis,
  },
  data() {
    return {
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '50', '100', '200'],
      },
      loading: false,
      title: '操作',
      visible: false,
      disableMixinCreated: false,
      toFromType: '',
      currentMaterialId: '',
      dataSource: [],
      fileName: '',
      uuid: '',
      // 表头
      columns: [
        {"title":"包装级别","dataIndex":"ptype",scopedSlots: { customRender: 'packType' }},
        {"title":"UDI编码","dataIndex":"code"},
      ],
      labelCol: {
        xs: { span: 1 },
        sm: { span: 2 },
      },
      wrapperCol: {
        xs: { span: 10 },
        sm: { span: 16 },
      },
      url:{
        list:'/dataAcquisitionAccumulatedV2/codeDetail'
      }
    }
  },
  created() {},
  methods: {
    async show(e) {
      this.visible = true

      this.topQueryParam.uuid = e.uuid
      this.dataSource = []
      this.loadData(1)
    },
    close() {
      this.$emit('close')
      this.visible = false
      if (!this.uuid) {
        this.$emit('fatherMethod')
      }
    },
    handleCancel() {
      this.close()
    },

    myHandleDetail(record) {
      let that = this
      this.toFromType = record.fromType
      findBillDetailByNumber({ number: record.number }).then((res) => {
        if (res && res.code === 200) {
          this.$refs.billDetail.isCanBackCheck = false
          that.$refs.billDetail.show(res.data, record.type)
          that.$refs.billDetail.title = '详情'
        }
      })
    },

  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>